import {useAppSelector} from '@/hooks';

export function useSingleActivePosterItemId(): string | null {
  const singleActiveId = useAppSelector((state) => {
    return state.posterEditor.activeItemIds[0];
  });

  return singleActiveId ?? null;
}
